
$(document).ready(function() {
    let button_processing_text = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Processing...';
    // Initialize Stripe first
    // check if stripe exists
    if (typeof Stripe === 'undefined') {
        console.log('Stripe is not defined');
        return false;
    }
    if($('#card-number-element').length <= 0) {
        return false;
    }

    const elements = stripe.elements();

    const style = {
        base: {
            fontSize: '16px',
            color: '#32325d',
            '::placeholder': {
                color: '#a0aec0',
            },
        },
        invalid: {
            color: '#e53e3e',
        }
    };

    // Create separate card elements
    const cardNumber = elements.create('cardNumber', {
        style,
        showIcon: true
    });
    cardNumber.mount('#card-number-element');

    const cardExpiry = elements.create('cardExpiry', { style });
    cardExpiry.mount('#card-expiry-element');

    const cardCvc = elements.create('cardCvc', { style });
    cardCvc.mount('#card-cvc-element');

    const cardPostalCode = elements.create('postalCode', {
        style,
        placeholder: '12345'
    });
    cardPostalCode.mount('#card-postal-code-element');

    // Error handling for Stripe elements
    const stripeElementErrors = {
        'cardNumber': 'card-number-error',
        'cardExpiry': 'card-expiry-error',
        'cardCvc': 'card-cvc-error',
        'postalCode': 'card-postal-code-error'
    };

    // Track validation state
    const validationState = {
        cardholderName: false,
        email: false,
        cardNumber: false,
        cardExpiry: false,
        cardCvc: false,
        postalCode: false
    };

    // Validate form fields
    function validateForm() {
        let isValid = true;

        // Validate cardholder name
        const cardholderName = $('#cardholder-name').val().trim();
        if (!cardholderName || cardholderName.length < 2) {
            showError('name-error', 'Please enter a valid cardholder name');
            $('#cardholder-name').addClass('input-error').removeClass('valid-input');
            validationState.cardholderName = false;
            isValid = false;
        } else {
            hideError('name-error');
            $('#cardholder-name').removeClass('input-error').addClass('valid-input');
            validationState.cardholderName = true;
        }

        // Validate email
        const email = $('#email').val().trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            showError('email-error', 'Please enter a valid email address');
            $('#email').addClass('input-error').removeClass('valid-input');
            validationState.email = false;
            isValid = false;
        } else {
            hideError('email-error');
            $('#email').removeClass('input-error').addClass('valid-input');
            validationState.email = true;
        }

        // Check all Stripe element validations
        for (const field in validationState) {
            if (field !== 'cardholderName' && field !== 'email' && !validationState[field]) {
                isValid = false;
            }
        }

        return isValid;
    }

    // Helper functions for error display
    function showError(id, message) {
        $(`#${id}`).text(message).show();
    }

    function hideError(id) {
        $(`#${id}`).hide();
    }

    // Listen for changes on all elements and validate them
    cardNumber.on('change', function(event) {
        if (event.error) {
            showError('card-number-error', event.error.message);
            validationState.cardNumber = false;
        } else if (!event.complete) {
            showError('card-number-error', 'Your card number is incomplete');
            validationState.cardNumber = false;
        } else {
            hideError('card-number-error');
            validationState.cardNumber = true;
        }
    });

    cardExpiry.on('change', function(event) {
        if (event.error) {
            showError('card-expiry-error', event.error.message);
            validationState.cardExpiry = false;
        } else if (!event.complete) {
            showError('card-expiry-error', 'Your expiration date is incomplete');
            validationState.cardExpiry = false;
        } else {
            hideError('card-expiry-error');
            validationState.cardExpiry = true;
        }
    });

    cardCvc.on('change', function(event) {
        if (event.error) {
            showError('card-cvc-error', event.error.message);
            validationState.cardCvc = false;
        } else if (!event.complete) {
            showError('card-cvc-error', 'Your CVC is incomplete');
            validationState.cardCvc = false;
        } else {
            hideError('card-cvc-error');
            validationState.cardCvc = true;
        }
    });

    cardPostalCode.on('change', function(event) {
        if (event.error) {
            showError('card-postal-code-error', event.error.message);
            validationState.postalCode = false;
        } else if (!event.complete) {
            showError('card-postal-code-error', 'Your postal code is incomplete');
            validationState.postalCode = false;
        } else {
            hideError('card-postal-code-error');
            validationState.postalCode = true;
        }
    });


    const original_text = $('#submit-button').html();
    // Add input validation as user types
    $('#cardholder-name').on('input', function() {
        const value = $(this).val().trim();
        if (value.length >= 2) {
            hideError('name-error');
            $(this).removeClass('input-error').addClass('valid-input');
            validationState.cardholderName = true;
        } else {
            $(this).removeClass('valid-input');
        }
    });

    $('#email').on('input', function() {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test($(this).val().trim())) {
            hideError('email-error');
            $(this).removeClass('input-error').addClass('valid-input');
            validationState.email = true;
        } else {
            $(this).removeClass('valid-input');
        }
    });

    // Handle form submission
    $('#payment-form').on('submit', async function(e) {
        e.preventDefault();

        // Validate form fields first
        if (!validateForm()) {
            // Focus on the first invalid field
            if (!validationState.cardholderName) {
                $('#cardholder-name').focus();
            } else if (!validationState.email) {
                $('#email').focus();
            } else if (!validationState.cardNumber) {
                cardNumber.focus();
            } else if (!validationState.cardExpiry) {
                cardExpiry.focus();
            } else if (!validationState.cardCvc) {
                cardCvc.focus();
            } else if (!validationState.postalCode) {
                cardPostalCode.focus();
            }
            return;
        }

        $('#error-message').hide();
        $('#submit-button').prop('disabled', true);
        $('#submit-button').html(button_processing_text);


        const cardholderName = $('#cardholder-name').val();
        const email = $('#email').val();

        const api_url = url + '/api';
        try {
            // Create payment intent on server
            const response = await fetch(api_url + '/payment-intent', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                body: JSON.stringify({
                    email: email,
                    order_id: $('#submit-button').attr('order-id'),
                    name: cardholderName
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to create payment intent');
            }

            const { clientSecret } = await response.json();

            // Confirm card payment
            const { paymentIntent, error } = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: cardNumber,
                    billing_details: {
                        name: cardholderName,
                        email: email,
                        address: {
                            postal_code: document.getElementById('card-postal-code-element').value
                        }
                    }
                },
                receipt_email: email
            });

            if (error) {
                $('#submit-button').prop('disabled', false);
                $('#submit-button').html('Try Again');

                // Highlight the problematic field
                if (error.code === 'incomplete_number') {
                    showError('card-number-error', 'Your card number is incomplete');
                    cardNumber.focus();
                } else if (error.code === 'incomplete_expiry') {
                    showError('card-expiry-error', 'Your expiration date is incomplete');
                    cardExpiry.focus();
                } else if (error.code === 'incomplete_cvc') {
                    showError('card-cvc-error', 'Your CVC is incomplete');
                    cardCvc.focus();
                } else if (error.code === 'incomplete_postal_code') {
                    showError('card-postal-code-error', 'Your postal code is incomplete');
                    cardPostalCode.focus();
                }
            } else if (paymentIntent.status === 'succeeded') {
                // Payment succeeded - handle success
                $('#payment-form')[0].reset();

                // Optional: Send confirmation to your server
                try {
                    const confirmResponse = await fetch(api_url + '/payment-confirm', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        body: JSON.stringify({
                            payment_intent: paymentIntent.id,
                            email: email
                        })
                    });

                    const result = await confirmResponse.json();
                    if(result.status === 'success'){
                        $('.payment-form-status-overlay').show()
                        $('#success-message').html('<i class="fa-solid fa-check"></i> Order placed successfully!').show();
                        $('#submit-button').html('Payment Successful!');
                    }else{
                        $('#success-message').hide();
                        $('#error-message').html(`<i class="fa-solid fa-times"></i> ${result.message}`).show();
                        $('#submit-button').html('Try Again');
                        $('#submit-button').prop('disabled', false);
                    }
                    console.log('Confirmation result:', result);
                } catch (confirmError) {
                    console.error('Confirmation error:', confirmError);
                }
            }
        } catch (err) {
            console.error(err);
            $('#card-errors').text('Unable to process payment, Please try again.').show();
            $('#submit-button').prop('disabled', false);
            $('#submit-button').html(original_text);
        }
    });

    // Initialize all error messages as hidden
    $('.error-message').hide();
});
